<div class="read-to-write read-to-write-input">
  @switch (mode()) {
    @case (EReadToWriteMode.read) {
      <div class="read-mode-field">{{ formControl().value ?? '' }}</div>
    }
    @case (EReadToWriteMode.write) {
      <mat-form-field appearance="outline">
        <mat-label>{{ label() }}</mat-label>
        <input matInput [formControl]="formControl()" type="{{ inputType() }}" />
        <mat-error [control]="formControl()"></mat-error>
      </mat-form-field>
    }
  }
</div>
